module.exports = __webpack_public_path__ + "img/opportunity-for-education-industry-digital-transformation.0da5f9da.jpg";